module.exports = __webpack_public_path__ + "static/media/logo.9765eab0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = 2035
// module chunks = 0